// extracted by mini-css-extract-plugin
module.exports = {"link":"InlineLink_link__2oHot","icon":"InlineLink_icon__33Zpr"};